<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxChartLabel">Chart Label</label>
                    <input id="txbxChartLabel" type="text" class="form-control" [(ngModel)]="target.chartLabel" name="chartLabel" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxfullName">Date</label>
                    <wj-input-date [(ngModel)]="target.date" name="date" [isRequired]="true"></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxDescription">Description</label>
                    <input id="txbxDescription" type="text" class="form-control" [(ngModel)]="target.description" name="description" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
